// extracted by mini-css-extract-plugin
export default {"steamIcon":"steam-icon_steamIcon__yPQqP"};